export const MY_PROFILE_SECTION_QUERY_PARAM = 'section'
export const MY_PROFILE_AI_SECTION = 'ai'
